/*
 * THIS FILE WAS GENERATED BY "@atproto/lex". DO NOT EDIT.
 */

import { l } from '@atproto/lex'

const $nsid = 'app.bsky.video.getUploadLimits'

export { $nsid }

export const $params = /*#__PURE__*/ l.params()

export type $Params = l.InferOutput<typeof $params>

export const $output = /*#__PURE__*/ l.jsonPayload({
  canUpload: /*#__PURE__*/ l.boolean(),
  remainingDailyVideos: /*#__PURE__*/ l.optional(/*#__PURE__*/ l.integer()),
  remainingDailyBytes: /*#__PURE__*/ l.optional(/*#__PURE__*/ l.integer()),
  message: /*#__PURE__*/ l.optional(/*#__PURE__*/ l.string()),
  error: /*#__PURE__*/ l.optional(/*#__PURE__*/ l.string()),
})

export type $Output<B = l.BinaryData> = l.InferPayload<typeof $output, B>
export type $OutputBody<B = l.BinaryData> = l.InferPayloadBody<
  typeof $output,
  B
>

/** Get video upload limits for the authenticated user. */
const main = /*#__PURE__*/ l.query($nsid, $params, $output)

export { main }

export const $lxm = $nsid
